import { trackPromise } from 'react-promise-tracker';
import {fetchWithAuth} from './fetchWithAuth'
export async function getAllCandidates(userToken) {
    return trackPromise(
        fetchWithAuth(
            'https://t41bx8uqf6.execute-api.us-east-2.amazonaws.com/prod/votacion/listado_candidatos_completo',
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'authorizationToken': userToken
                }
            }
        )
    );
}